import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyledMobileNav = styled.nav`
    & > ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }
`;

export const StyledLink = styled(NavLink)`
    font-size: 1rem;
    color: ${colors.subtleText};
    display: block;
    padding: 1em 0 0.9em;
    text-decoration: none;

    outline-offset: -2px !important;

    padding-left: 60px;
    ${media.tablet`
      padding-left: 32px;
    `};

    ${media.tabletSmall`
      padding-left: 20px;
    `};

    &.active {
        background-color: ${colors.highlight};
        border-left: 4px solid ${colors.secondary};
        pointer-events: none;
    }

    &:hover {
        text-decoration: underline;
    }
`;



// WEBPACK FOOTER //
// ./src/modules/Header/components/MobileMenu/components/MobileNav/styled.js